import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy(props) {
  const navigate = useNavigate();

  const deleteProfile = () => {
    navigate('/Delete');
  };

  // const [userDetails, setUserDetails] = useState(null);

  // useEffect(() => {
  //   const tokenValue = localStorage.getItem("tokenValue");
  //   if (tokenValue !== null) {
  //     const userDetails = JSON.parse(localStorage.getItem("TM_UDetails"));
  //     setUserDetails(userDetails);
  //   }
  // }, []);

  return (
    <div>
      

      <div className="container" style={{ paddingTop: '25px' }}>
        <h2>Privacy Policy</h2>
        <p>At Travel Mythri, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and protect the data you provide to us. Please read this policy carefully to understand our practices.</p>
        <h5>1. Information We Collect</h5>
        <p>We may collect the following information from you when you use the Travel Mythri app:</p>
        <h6>1.1. User Information:</h6>
        <ul>
          <li>Mobile Number</li>
          <li>Email Address</li>
          <li>Full Name</li>
          <li>Gender (for authentication purposes)</li>
        </ul>
        <h6>1.2. Optional Information:</h6>
        <ul>
          <li>Customer Address (for developer communication)</li>
        </ul>
        <h6>1.3. Device Information:</h6>
        <ul>
          <li>Device ID (for app functionality)</li>
        </ul>
        <h6>1.4. SMS Data:</h6>
        <ul>
          <li>Travel Mythri may request access to SMS messages on your device for the purpose of OTP (One-Time Password) verification. We do not store or access the content of your SMS messages, and this access is solely for the purpose of receiving OTPs sent by our system.</li>
        </ul>
        <h5>2. Use of Information</h5>
        <p>We use the information we collect for the following purposes:</p>
        <h6>2.1. Authentication:</h6>
        <ul>
          <li>Mobile Number, Email, Name, and Gender are collected to verify your identity and ensure the security of your Travel Mythri account.</li>
        </ul>
        <h6>2.2. Developer Communication:</h6>
        <ul>
          <li>If you provide your address as optional information, it may be used for communication related to app development or to send you important updates.</li>
        </ul>
        <h6>2.3. App Functionality:</h6>
        <ul>
          <li>Device ID is collected for the proper functioning of the Travel Mythri app.</li>
        </ul>
        <h5>3. Data Sharing</h5>
        <p>We do not share your collected data with third parties. Your information is securely stored and used only for the purposes outlined in this Privacy Policy.</p>
        <h5>4. Data Security</h5>
        <p>We take data security seriously and have implemented technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.</p>
        <h5>5. Cookies and Tracking</h5>
        <p>Travel Mythri may use cookies and other tracking technologies to enhance your experience. You can manage your cookie preferences through the app's settings.</p>
        <h5>6. Changes to this Privacy Policy</h5>
        <p>Travel Mythri may update this Privacy Policy from time to time. You will be notified of any significant changes through the app or via email.</p>
        <h5>How long do we keep your personal information?</h5>
        <ul>
          <li>Your personal information will be stored on Travel Mythri's servers for a reasonable duration as required for the outlined purposes in this policy. In certain situations, we might retain your personal information for extended periods, especially when mandated by legal, regulatory, tax, or accounting obligations.</li>
          <li>Once your personal data is no longer necessary, we will guarantee its secure deletion or storage in a manner that ensures it is no longer accessible or utilized by the company.</li>
          {/* {userDetails && userDetails.userId > 0 && ( */}
          <li>If users wish to delete their accounts, they can do so by following this 
          
                <a onClick={deleteProfile} style={{ color: 'blue', cursor: 'pointer' }}>Link</a>    
          </li>
          {/* )} */}
        </ul>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
